import { useState } from "react";
//import { Link, useLoaderData, useNavigate } from "react-router-dom";
import { Link, useRouteLoaderData, useNavigate, useOutletContext } from "react-router-dom";
import Modal from "../../components/UI/Modal";
import PersonalCard from "../../components/UI/PersonalCard";
import {Api, userRoles} from "../../utils/api";

import DiagnosticsWrapper from "../../components/UI/DiagnosticsWrapper";
import {checkUser} from "../../store/auth-context";

const PatientDetails = () => {
    const data = useRouteLoaderData('patient-details');

    const [modalIsShown, setModalIsShown] = useState(false);

    const navigate = useNavigate();

    const [serverErrors, setServerErrors] = useOutletContext(data.errors);

    const checkedRole = checkUser([userRoles.superAdmin, userRoles.admin, userRoles.employee]);

    const deletePatientHandler = (id) => {
        Api.deletePatient(id).then(async (result) => {
            if (result === true) {
                navigate('/patients');
                setServerErrors([]);
            }
        },
        (errors) => {
            setServerErrors(errors.errors);
        });
    }

    return (
        <>
        {modalIsShown && 
        <Modal message={'Сигурни ли сте?'} onCancel={() => {setModalIsShown(false);}} onConfirm={() => {deletePatientHandler(data.patients.id); setModalIsShown(false);}}></Modal>}
        <section className='lists'>
            <h1>{data.patients.name} {data.patients.family}<span className="action in-title">
                {checkedRole !== userRoles.employee &&
                <button className="edit"
                    onClick={() => {
                            navigate('edit');
                        }}>
                </button>
                }
                {checkedRole !== userRoles.employee && checkedRole !== userRoles.admin &&
                <button className="delete" 
                    onClick={() => {
                            setModalIsShown(true);
                        }}>
                </button>
                }
            </span></h1>
            <PersonalCard data={data.patients} />
        </section>
        <DiagnosticsWrapper data={data.diagnostics} patientId={data.patients.id} />
        <div className="back">
            <Link to=".." relative="path">
                <button>← Пациенти</button>
            </Link>
        </div>
        </>
    );
  }
  
  export default PatientDetails;
  